<template>
    <div style="overflow-x:hidden">
        <BannerStatic :ban="wWidth<768?banner[1]:banner[0]"></BannerStatic>
        <Hardware></Hardware>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import Hardware from '@/components/products/hardware/hardware.vue'

export default {
    components:{
        BannerStatic,
        Hardware
    },
    data(){
        return{
            banner: [require('@/assets/bannerVR.jpg'),require('@/assets/phone/bannerVR.png')],
            wWidth: window.screen.width
        }
    }
}
</script>